import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="text-xl font-heading text-foreground-950 whitespace-nowrap"
          >
            cssspreadsheet<span className="text-primary-500">.online</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                <span>Browse Categories</span>
                <i
                  className={`ri-arrow-down-s-line transition-transform duration-200 ${
                    dropdownOpen ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-56 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 max-h-[420px] overflow-y-auto animate-[fadeIn_0.15s_ease-out]">
                  {categories.map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer"
            >
              CSSBuy Sheet
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70 animate-[fadeIn_0.2s_ease-out] max-h-[calc(100vh-4rem)] overflow-y-auto">
            <div className="pt-3 space-y-1">
              <p className="px-3 text-xs font-medium text-foreground-400 uppercase tracking-wider mb-2">
                Categories
              </p>
              {categories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block px-3 py-2 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {cat.name}
                </a>
              ))}
              <div className="pt-3 px-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="block w-full text-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-all whitespace-nowrap"
                >
                  CSSBuy Sheet
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}